import { useDispatch, useSelector } from "react-redux";
import { getRegisterUsers, delRegisterUsers, updateUserStatus } from '../../redux/actions'
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify'
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { TableHead, TableRow, TableCell, Table, TableBody, TableSortLabel, TablePagination, makeStyles, useScrollTrigger } from "@material-ui/core";
import moment from 'moment'


const RegisteredUsers = () => {



  const dispatch = useDispatch();
  const user = useSelector((state) => state.userDetails);
  const usersize = useSelector((state) => state.userDetails.NumberRegisterUser);
  const [search, setsearch] = useState("")
  const [searchflag, setsearchflag] = useState(false)
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState("#000000");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [skip, setskip] = React.useState(0)
  const [trigger, setTrigger] = React.useState(1)
  const [getDelClass, setDelClass] = useState('hideModal');
  const [delLoading, setdelLoading] = useState(false)
  const [delDisable, setDelDisable] = useState(false)
  const [delcolor, setdelColor] = useState("#FF7E06")
  const [getDelId, setDelId] = useState();
  const [reset, setReset] = useState(false);

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  window.onmousedown = (e) => {
    const modals = document.getElementsByClassName("modal viewModal");
    // console.log("clicked!!! => ", e.target);
    // console.log("modal => ", modals[0]);
    if (modals[0] === e.target) {
      if (getDelClass === 'viewModal')
        setDelClass('hideModal')
    }
  }

  useEffect(() => {
    setLoading(true);
    const callback = () => {
      setLoading(false);
      setReset(false);
    }
    dispatch(getRegisterUsers({ skip: skip, limit: rowsPerPage, searchWords: search, searchflag: searchflag, callback }));
  }, [skip, rowsPerPage, page, trigger])

  useEffect(() => {
    setdata({ ...user.RegisterUser, rows: sortedItems })
    setDelClass('hideModal');
    setdelLoading(false);
    setDelDisable(false);
  }, [user.RegisterUser])

  useEffect(() => {
    if (search !== "") {
      setsearchflag(true)
    }
    else if (search === "") {
      setsearchflag(false)
    }
  }, [search])

  useEffect(() => {
    if (reset) {
      setsearch("");
    }
  }, [reset])

  useEffect(() => {
    if (reset && searchflag === false) {
      // console.log("INSIDE RESET & SEARCH FLAG", searchflag);
      onChangeSearch();
    }
  }, [searchflag])

  const onChangeSearch = () => {
    setPage(0);
    setskip(0);
    setRowsPerPage(rowsPerPage)
    // if (search !== "") {
    //   setsearchflag(true)
    // }
    // else if (search == "") {
    //   setsearchflag(false)
    // }
    const new_trg = trigger + 1
    setTrigger(new_trg)
  }

  const handleChangePage = (event, newPage) => {

    const upcoming_result = ((newPage + 1) * rowsPerPage) - rowsPerPage;
    setskip(upcoming_result)
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setskip(0);
    const new_trg = trigger + 1
    setTrigger(new_trg)
  };

  const delList = (check, id) => {
    if (check) {
      // const ifsub = useSelector((state) => state.productDetails.listing.find((cat)));
      // setCategoryProductAssocClass('viewModal')
      setDelClass('viewModal')
      setDelId(id)
    }
  }

  const deleteUser = async (id) => {
    try {
      const response = await axios.request({
        data: { id: id },
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': Cookies.get('token')
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/users/delete-user`
      })
      if (response.data.success) {
        dispatch(delRegisterUsers({ id: id }));
        const new_trg = trigger + 1
        setTrigger(new_trg)
        toast.success(response.data.message)
      }

    }
    catch (error) {
      toast.success(error)
    }

  }


  var defaultSortBy = "createdAt";
  var defaultSortOrder = "desc";
  let [sortBy, setsortBy] = useState(defaultSortBy)             // default sort column
  let [sortOrder, setsortOrder] = useState(defaultSortOrder)    // default sort order

  const sortData = (sortBy, sortOrder, rows) => {
    var itemsToSort = JSON.parse(JSON.stringify(rows || user.RegisterUser));
    var sortedItems = [];
    var compareFn = null;
    switch (sortBy) {
      case "createdAt":
        compareFn = (i, j) => {

          if (i.createdAt < j.createdAt) {
            return sortOrder === "desc" ? 1 : -1;
          } else {
            if (i.createdAt > j.createdAt) {
              return sortOrder === "desc" ? -1 : 1;
            }
            else {
              return 0;
            }
          }
        };
        break;
      case "name":
        compareFn = (i, j) => {

          if (i.firstname < j.firstname) {
            return sortOrder === "asc" ? -1 : 1;
          } else {
            if (i.firstname > j.firstname) {
              return sortOrder === "asc" ? 1 : -1;
            }
            else {
              return 0;
            }
          }
        };
        break;
      case "email":
        compareFn = (i, j) => {

          if (i.email < j.email) {
            return sortOrder === "asc" ? -1 : 1;
          } else {
            if (i.email > j.email) {
              return sortOrder === "asc" ? 1 : -1;
            }
            else {
              return 0;
            }
          }
        };
        break;


      default:
        break;
    }
    // console.log(`---->itemtosort${sortBy}`, itemsToSort)
    sortedItems = user ? itemsToSort.sort(compareFn) : '';
    // console.log('---->sortItems', sortedItems)
    return sortedItems;
  }

  const requestSort = (pSortBy) => {

    var newsortBy = sortBy;
    var newsortOrder = sortOrder;

    // console.log('-->newsortBy', newsortBy)
    // console.log('-->newsortOrder', newsortOrder)
    // console.log('-->pSortBy', pSortBy)

    return event => {
      if (pSortBy === newsortBy) {
        newsortOrder = newsortOrder === "asc" ? "desc" : "asc";
      } else {
        newsortBy = pSortBy;
        newsortOrder = "asc";
      }

      var sortedItems = sortData(newsortBy, newsortOrder);
      setdata({ ...data, rows: sortedItems })
      setsortBy(newsortBy)
      setsortOrder(newsortOrder)
    };
  }


  var sortedItems = sortData(defaultSortBy, defaultSortOrder, user.RegisterUser);
  const [data, setdata] = useState({ ...user.RegisterUser, rows: sortedItems })

  // useEffect(() => {
  //   if (data.rows) {
  //     for (let row of data.rows) {
  //       const checkbox = document.getElementById(`checkbox${row._id}`);
  //       console.log("checkBox: ", checkbox);
  //       if (row.is_active)
  //         // checkbox.checked = true;
  //         console.log("this row is true");
  //     }
  //   }
  // }, [data.rows])


  const handleToggle = async (e, id, email) => {
    if (e.target.checked) {
      // console.log("check state is checked");
      e.target.removeAttribute("checked");
      const response = await axios.request({
        data: { status: true, id, email },
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': Cookies.get('token')
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/users/update-status`
      });
      if (response.data.success) {
        e.target.checked = true;
        toast.success(response.data.message);
      }
      else
        toast.error(response.data.message);
    }
    else {
      // console.log("check state is not checked");
      e.target.removeAttribute("checked");
      const response = await axios.request({
        data: { status: false, id, email },
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': Cookies.get('token')
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/users/update-status`
      });
      if (response.data.success) {
        e.target.checked = false
        toast.success(response.data.message);
      }
      else
        toast.error(response.data.message);
    }
  }

  const handleUserRole = async (e, id, email) => {
    const response = await axios.request({
      data: { id, role: e.target.value, email },
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Cookies.get('token')
      },
      url: `${process.env.REACT_APP_SERVER_URL}/v1/users/update-role`
    });
    if (response.data.success)
      toast.success(response.data.message);
    else
      toast.error(response.data.message);
  }



  return (
    <>
      <div className="dashContentHeader d-flex justify-content-between align-items-center">
        <h5 className="dashHeading mb-0">Registered Users</h5>

      </div>
      <div className="dashboardCardRow">
        <div className="input-group mb-4 search-menu">
          <input type="text" className="form-control" onChange={(e) => { setsearch(e.target.value) }} onKeyDown={(e) => { if (e.keyCode === 13) { onChangeSearch() } }} value={search} placeholder="Search using Email..." />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search" aria-hidden="true"></i>
            </span>
          </div>
          <button className="btn btn-custom-1" onClick={() => setReset(true)}>
            <i class="fa fa-refresh" aria-hidden="true"></i> Reset</button>

        </div>
        <div className="listingTableRow">
          <div className="listingTableHeader d-flex justify-content-between">

            <div className="d-flex justify-content-end">



            </div>
          </div>
          <div className="table-responsive">



            {/* <th>Name</th>

                                <th>Role</th>
                                <th>Email</th>
                                <th>Actions</th> */}

            <Table className="table customDashboardTable">

              <TableHead>
                <TableRow>

                  <TableCell> <TableSortLabel active={sortBy === "name"} direction={sortOrder} onClick={requestSort("name")}>Name </TableSortLabel> </TableCell>
                  <TableCell>  Role </TableCell>
                  <TableCell> <TableSortLabel active={sortBy === "email"} direction={sortOrder} onClick={requestSort("email")}>Email </TableSortLabel></TableCell>
                  <TableCell>Joining Date </TableCell>
                  <TableCell>Status</TableCell>
                  {user.user.superAdmin && <TableCell>Role</TableCell>}
                  <TableCell className="action-col"> Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>

                {loading &&
                  (
                    <TableRow >
                      <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                      <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                      <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                      <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                      <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                      {user.user.superAdmin && <TableCell><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>}
                      <TableCell className="action-col"><SyncLoader color={color} loading={loading} css={override} size={11} /> </TableCell>
                    </TableRow>
                  )}

                {!loading && data.rows && data.rows
                  // .filter(users => users.firstname.toLowerCase().includes(search.toLowerCase()) || users.email.toLowerCase().includes(search.toLowerCase()) || users.role[0].toLowerCase().includes(search.toLowerCase()) )
                  // .filter(function (user_tmp) { if (user_tmp._id === user.user._id) { return false; }  return true;})

                  .map((user_tmp, key) => {
                    // console.log("createdAt: ", moment(user_tmp.createdAt).format('MMMM Do YYYY'));
                    return (
                      <TableRow key={key}>

                        <TableCell>  <div className="d-flex align-items-center">{user_tmp.firstname}</div>
                          {/* <span className="circle-style mr-3 bg1">{user_tmp.firstname[0]}</span> */}
                        </TableCell>
                        <TableCell> {user_tmp.superAdmin ? "superAdmin" : user_tmp.role[0]}</TableCell>
                        <TableCell>  <div className="orange-text">{user_tmp.email}</div>  </TableCell>
                        <TableCell>{moment(user_tmp.joiningDate).format('MMMM Do YYYY')}</TableCell>
                        <TableCell>
                          {user_tmp._id !== user.user._id && !user_tmp?.superAdmin && <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id={`customSwitch${user_tmp._id}`} onChange={(e) => handleToggle(e, user_tmp._id, user_tmp.email)} checked={user_tmp.is_active ? true : false} />
                            {/* checked={user_tmp.is_active ? true : false} */}
                            <label class="custom-control-label" for={`customSwitch${user_tmp._id}`}></label>
                          </div>}
                        </TableCell>
                        {user.user.superAdmin && <TableCell>
                          {user_tmp._id !== user.user._id && <select onChange={(e) => handleUserRole(e, user_tmp._id, user_tmp.email)}>
                            <option value="admin" selected={user_tmp.role[0] === "admin" ? true : false}>Admin</option>
                            <option value="user" selected={user_tmp.role[0] === "user" ? true : false}>User</option>
                          </select>}
                        </TableCell>}
                        <TableCell className="action-col">  {user_tmp._id !== user.user._id && !user_tmp?.superAdmin && <div className="dropdown">
                          {/* <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                              <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                              <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                            </svg>
                          </button> */}
                          <ul className="action-list list-unstyled mb-0 d-flex justify-content-center">
                            <li onClick={() => { delList(true, user_tmp._id) }}>
                              <i className="fa fa-trash"></i>
                            </li>
                          </ul>
                          <div className="dropdown-menu dropdown-menu-right table-action" aria-labelledby="dropdownMenuButton">

                            <div>
                              {/* <button className="dropdown-item" onClick={() => { deleteUser(user_tmp._id) }}>
                                <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 4.20044H2.6H15.4" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M4.99961 4.2V2.6C4.99961 2.17565 5.16818 1.76869 5.46824 1.46863C5.7683 1.16857 6.17526 1 6.59961 1H9.79961C10.224 1 10.6309 1.16857 10.931 1.46863C11.231 1.76869 11.3996 2.17565 11.3996 2.6V4.2M13.7996 4.2V15.4C13.7996 15.8243 13.631 16.2313 13.331 16.5314C13.0309 16.8314 12.624 17 12.1996 17H4.19961C3.77526 17 3.3683 16.8314 3.06824 16.5314C2.76818 16.2313 2.59961 15.8243 2.59961 15.4V4.2H13.7996Z" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M6.59961 8.19995V13" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M9.79883 8.19995V13" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                Delete</button> */}
                              {/* <ul className="action-list list-unstyled mb-0 d-flex">
                                <li onClick={() => { deleteUser(user_tmp._id) }}>
                                  <i className="fa fa-trash"></i>
                                </li>
                              </ul> */}
                            </div>
                          </div>
                        </div>}


                        </TableCell>

                      </TableRow>)
                  })}
              </TableBody>
            </Table>
            <TablePagination rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]} component="div" count={usersize ? usersize : 0} rowsPerPage={rowsPerPage} page={page} onChangePage={handleChangePage} onChangeRowsPerPage={handleChangeRowsPerPage} />












            {/* <tr>
                                <th>Name</th>
                                
                                <th>Role</th>
                                <th>Email</th>
                                <th>Actions</th>

                            </tr>
                            {loading &&
                                (
                                    <tr>
                                        <td><SyncLoader color={color} loading={loading} css={override} size={11} /></td>
                                        <td><SyncLoader color={color} loading={loading} css={override} size={11} /></td>
                                        <td><SyncLoader color={color} loading={loading} css={override} size={11} /></td>
                                        <td><SyncLoader color={color} loading={loading} css={override} size={11} /></td>
                                     
                                    </tr>
                                )} */}

            {/* {!loading && user.RegisterUser && user.RegisterUser.filter(users => users.firstname.toLowerCase().includes(search.toLowerCase()) || users.email.toLowerCase().includes(search.toLowerCase()) || users.role[0].toLowerCase().includes(search.toLowerCase()) ).filter(function (user_tmp) { if (user_tmp._id === user.user._id) { return false; }  return true;
                            }).map((user_tmp) => {
                                return (<tr>
                                    <td className="d-flex align-items-center"><span className="circle-style mr-3 bg1">{user_tmp.firstname[0]}</span>{user_tmp.firstname}</td>

                                    <td>{user_tmp.role[0]}</td>
                                    <td className="orange-text">{user_tmp.email}</td>
                                    <td><div className="dropdown">
                                        <button className="btn btn-link dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                                <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                                <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                                            </svg>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-right table-action" aria-labelledby="dropdownMenuButton">
                                           
                                            <div>
                                                <button className="dropdown-item" onClick={() => { deleteUser(user_tmp._id) }}>
                                                    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 4.20044H2.6H15.4" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M4.99961 4.2V2.6C4.99961 2.17565 5.16818 1.76869 5.46824 1.46863C5.7683 1.16857 6.17526 1 6.59961 1H9.79961C10.224 1 10.6309 1.16857 10.931 1.46863C11.231 1.76869 11.3996 2.17565 11.3996 2.6V4.2M13.7996 4.2V15.4C13.7996 15.8243 13.631 16.2313 13.331 16.5314C13.0309 16.8314 12.624 17 12.1996 17H4.19961C3.77526 17 3.3683 16.8314 3.06824 16.5314C2.76818 16.2313 2.59961 15.8243 2.59961 15.4V4.2H13.7996Z" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M6.59961 8.19995V13" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M9.79883 8.19995V13" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>

                                                    Delete</button></div>
                                          

                                        </div>
                                    </div></td>
                                </tr>)
                            }

                            )} */}
            {/* </table> */}
          </div>
        </div>
      </div>
      <div id="delModal" className={`modal ${getDelClass}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header px-4">
              <h5 className="modal-title">Delete List Item</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setDelClass('hideModal') }}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body modal-padding">
              <div className="text-center d-flex flex-column delete-modal">
                <div>
                  <h6 className="text-uppercase">Are you sure you want to delete this User ?</h6>
                </div>
                <div>
                  <button className="btn btn-custom mr-2" disabled={delDisable} onClick={() => { setDelClass('hideModal') }}>No</button>
                  <button className="btn btn-custom" disabled={delDisable} onClick={() => { deleteUser(getDelId); setdelLoading(true); setDelDisable(true) }} id="whiteBtn">
                    {delLoading && <SyncLoader color={delcolor} loading={delLoading} css={override} size={11} />}
                    {!delLoading && "Yes"}

                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisteredUsers;